import React, {
useEffect,
useState,
} from "react";

import {
Modal,
Descriptions,
Table,
Tag,
Spin,
Empty,
Button,
message,
} from "antd";

import {
DollarOutlined,
DownloadOutlined,
} from "@ant-design/icons";

import {
pdf,
} from "@react-pdf/renderer";

import api from "../api/api";

import OtherFeePaymentRecieptPDF
from "./OtherFeePaymentRecieptPDF";

import "./FeesDetailsPopup.css";

const FeesDetailsPopup = ({
open,
payment,
onClose,
}) => {


const [
    loading,
    setLoading,
] = useState(false);


const [
    downloadingReceipt,
    setDownloadingReceipt,
] = useState(false);


const [
    paymentHistory,
    setPaymentHistory,
] = useState([]);


useEffect(() => {

    if (
        !open ||
        !payment
    ) {

        setPaymentHistory([]);

        return;

    }


    const fetchPaymentHistory = async () => {

        try {

            setLoading(true);


            const response = await api.get(

                "/other-fee-payments/",

                {
                    params: {

                        student:
                            payment.student,

                        fee_type:
                            payment.fee_type,

                    },

                }

            );


            const data =
                response.data;


            setPaymentHistory(

                data.results ||
                data ||
                []

            );

        } catch (error) {

            console.error(

                "Error fetching payment history:",

                error

            );


            message.error(

                "Unable to load payment history."

            );

        } finally {

            setLoading(false);

        }

    };


    fetchPaymentHistory();

}, [
    open,
    payment,
]);


const handleDownloadReceipt = async () => {

    try {

        if (
            !payment
        ) {

            message.warning(

                "No payment selected."

            );

            return;

        }


        if (
            paymentHistory.length === 0
        ) {

            message.warning(

                "There is no payment history available for this receipt."

            );

            return;

        }


        setDownloadingReceipt(true);


        message.loading({

            content:
                "Preparing receipt PDF...",

            key:
                "receipt-download",

        });


        const blob = await pdf(

            <OtherFeePaymentRecieptPDF

                payment={
                    payment
                }

                paymentHistory={
                    paymentHistory
                }

            />

        ).toBlob();


        const url =
            URL.createObjectURL(

                blob

            );


        const link =
            document.createElement(

                "a"

            );


        link.href =
            url;


        link.download =

            `Other-Fee-Receipt-${payment.id}.pdf`;


        document.body.appendChild(

            link

        );


        link.click();


        document.body.removeChild(

            link

        );


        URL.revokeObjectURL(

            url

        );


        message.success({

            content:
                "Receipt downloaded successfully.",

            key:
                "receipt-download",

        });

    } catch (error) {

        console.error(

            "Receipt download error:",

            error

        );


        message.error({

            content:
                "Unable to generate receipt.",

            key:
                "receipt-download",

        });

    } finally {

        setDownloadingReceipt(false);

    }

};


const formatAmount =
    value => {

        return Number(

            value || 0

        ).toFixed(2);

    };


const formatMonth =
    value => {

        if (
            !value
        ) {

            return "N/A";

        }


        return (

            value
                .charAt(0)
                .toUpperCase()
            +
            value.slice(1)

        );

    };


const columns = [

    {

        title:
            "Date",

        dataIndex:
            "date",

        key:
            "date",

    },


    {

        title:
            "Fee Type",

        dataIndex:
            "fee_type_name",

        key:
            "fee_type_name",

    },


    {

        title:
            "Payer",

        dataIndex:
            "payer_name",

        key:
            "payer_name",

    },


    {

        title:
            "Total Amount",

        dataIndex:
            "total_amount",

        key:
            "total_amount",

        render:
            value => (

                <strong
                    className="amount-total"
                >

                    {
                        formatAmount(
                            value
                        )
                    }

                </strong>

            ),

    },


    {

        title:
            "Amount Paid",

        dataIndex:
            "amount_paid",

        key:
            "amount_paid",

        render:
            value => (

                <Tag
                    color="green"
                >

                    {
                        formatAmount(
                            value
                        )
                    }

                </Tag>

            ),

    },


    {

        title:
            "Balance",

        dataIndex:
            "balance",

        key:
            "balance",

        render:
            value => (

                <Tag

                    color={

                        Number(
                            value || 0
                        ) > 0

                            ? "red"

                            : "green"

                    }

                >

                    {
                        formatAmount(
                            value
                        )
                    }

                </Tag>

            ),

    },


    {

        title:
            "Month",

        dataIndex:
            "month",

        key:
            "month",

        render:
            formatMonth,

    },

];


return (

    <Modal

        className="fees-details-modal"

        open={
            open
        }

        onCancel={
            onClose
        }

        maskClosable={false}
        keyboard={false}

        footer={
            null
        }

        width={

            window.innerWidth < 768

                ? "95%"

                : 1100

        }

        centered

        destroyOnClose

        title={

            <div
                className="fees-modal-title"
            >

                <div
                    className="fees-modal-icon"
                >

                    <DollarOutlined />

                </div>


                <div>

                    <div
                        className="fees-modal-heading"
                    >

                        Payment Details

                    </div>


                    <div
                        className="fees-modal-subtitle"
                    >

                        Other Fee Payment Information

                    </div>

                </div>

            </div>

        }

    >

        {/* DOWNLOAD RECEIPT */}

        <br/>

        <div
            className="receipt-button-wrapper"
        >

            <Button

                className="download-receipt-button"

                type="primary"

                icon={

                    <DownloadOutlined />

                }

                onClick={

                    handleDownloadReceipt

                }

                loading={

                    downloadingReceipt

                }

                disabled={

                    loading ||
                    paymentHistory.length === 0

                }

            >

                Download Receipt

            </Button>

        </div>


        {/* PAYMENT SUMMARY */}

        {payment && (

            <div
                className="payment-summary-section"
            >

                <div
                    className="section-title"
                >

                    Payment Summary

                </div>


                <Descriptions

                    bordered

                    column={{

                        xs:
                            1,

                        sm:
                            2,

                        md:
                            3,

                    }}

                >

                    <Descriptions.Item

                        label="Fee Type"

                    >

                        {
                            payment.fee_type_name
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Payer"

                    >

                        {
                            payment.payer_name
                            ||
                            "N/A"
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Student"

                    >

                        {
                            payment.student_name
                            ||
                            "Manual Payer"
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Class"

                    >

                        {
                            payment.student_class_name
                            ||
                            "N/A"
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Academic Year"

                    >

                        {
                            payment.academic_year_name
                            ||
                            "N/A"
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Date"

                    >

                        {
                            payment.date
                            ||
                            "N/A"
                        }

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Total Amount"

                    >

                        <strong
                            className="summary-total"
                        >

                            {
                                formatAmount(
                                    payment.total_amount
                                )
                            }

                        </strong>

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Amount Paid"

                    >

                        <Tag
                            color="green"
                        >

                            {
                                formatAmount(
                                    payment.amount_paid
                                )
                            }

                        </Tag>

                    </Descriptions.Item>


                    <Descriptions.Item

                        label="Balance"

                    >

                        <Tag

                            color={

                                Number(
                                    payment.balance || 0
                                ) > 0

                                    ? "red"

                                    : "green"

                            }

                        >

                            {
                                formatAmount(
                                    payment.balance
                                )
                            }

                        </Tag>

                    </Descriptions.Item>

                </Descriptions>

            </div>

        )}


        {/* PAYMENT HISTORY */}

        <div
            className="payment-history-section"
        >

            <div
                className="section-title"
            >

                Payment History

            </div>


            {loading ? (

                <div
                    className="payment-loading"
                >

                    <Spin
                        size="large"
                    />

                </div>

            ) : paymentHistory.length === 0 ? (

                <Empty

                    description=
                        "No payment history found."

                />

            ) : (

                <Table

                    className="payment-history-table"

                    rowKey="id"

                    columns={
                        columns
                    }

                    dataSource={
                        paymentHistory
                    }

                    pagination={{

                        pageSize:
                            5,

                        showSizeChanger:
                            true,

                    }}

                    scroll={{
                        x:
                            true,
                    }}

                />

            )}

        </div>

    </Modal>

);


};

export default FeesDetailsPopup;






// import React, {
// useEffect,
// useState,
// } from "react";

// import {
// Modal,
// Descriptions,
// Table,
// Tag,
// Spin,
// Empty,
// Button,
// message,
// } from "antd";

// import {
// DollarOutlined,
// DownloadOutlined,
// } from "@ant-design/icons";

// import {
// pdf,
// } from "@react-pdf/renderer";

// import api from "../api/api";

// import OtherFeePaymentRecieptPDF
// from "./OtherFeePaymentRecieptPDF";

// const FeesDetailsPopup = ({
// open,
// payment,
// onClose,
// }) => {


// const [
//     loading,
//     setLoading,
// ] = useState(false);


// const [
//     downloadingReceipt,
//     setDownloadingReceipt,
// ] = useState(false);


// const [
//     paymentHistory,
//     setPaymentHistory,
// ] = useState([]);


// useEffect(() => {

//     if (
//         !open ||
//         !payment
//     ) {

//         setPaymentHistory([]);

//         return;

//     }


//     const fetchPaymentHistory = async () => {

//         try {

//             setLoading(true);


//             const response = await api.get(

//                 "/other-fee-payments/",

//                 {
//                     params: {

//                         student:
//                             payment.student,

//                         fee_type:
//                             payment.fee_type,

//                     },

//                 }

//             );


//             const data = response.data;


//             setPaymentHistory(

//                 data.results ||
//                 data ||
//                 []

//             );

//         } catch (error) {

//             console.error(

//                 "Error fetching payment history:",

//                 error

//             );


//             message.error(

//                 "Unable to load payment history."

//             );

//         } finally {

//             setLoading(false);

//         }

//     };


//     fetchPaymentHistory();

// }, [
//     open,
//     payment,
// ]);


// const handleDownloadReceipt = async () => {

//     try {

//         if (
//             !payment
//         ) {

//             message.warning(

//                 "No payment selected."

//             );

//             return;

//         }


//         if (
//             paymentHistory.length === 0
//         ) {

//             message.warning(

//                 "There is no payment history available for this receipt."

//             );

//             return;

//         }


//         setDownloadingReceipt(true);


//         message.loading({

//             content:
//                 "Preparing receipt PDF...",

//             key:
//                 "receipt-download",

//         });


//         const blob = await pdf(

//             <OtherFeePaymentRecieptPDF

//                 payment={
//                     payment
//                 }

//                 paymentHistory={
//                     paymentHistory
//                 }

//             />

//         ).toBlob();


//         const url = URL.createObjectURL(

//             blob

//         );


//         const link =
//             document.createElement(

//                 "a"

//             );


//         link.href = url;


//         link.download =

//             `Other-Fee-Receipt-${payment.id}.pdf`;


//         document.body.appendChild(

//             link

//         );


//         link.click();


//         document.body.removeChild(

//             link

//         );


//         URL.revokeObjectURL(

//             url

//         );


//         message.success({

//             content:
//                 "Receipt downloaded successfully.",

//             key:
//                 "receipt-download",

//         });

//     } catch (error) {

//         console.error(

//             "Receipt download error:",

//             error

//         );


//         message.error({

//             content:
//                 "Unable to generate receipt.",

//             key:
//                 "receipt-download",

//         });

//     } finally {

//         setDownloadingReceipt(false);

//     }

// };


// const columns = [

//     {

//         title:
//             "Date",

//         dataIndex:
//             "date",

//         key:
//             "date",

//     },


//     {

//         title:
//             "Fee Type",

//         dataIndex:
//             "fee_type_name",

//         key:
//             "fee_type_name",

//     },


//     {

//         title:
//             "Payer",

//         dataIndex:
//             "payer_name",

//         key:
//             "payer_name",

//     },


//     {

//         title:
//             "Total Amount",

//         dataIndex:
//             "total_amount",

//         key:
//             "total_amount",

//         render: value => (

//             <strong>

//                 {Number(

//                     value || 0

//                 ).toFixed(2)}

//             </strong>

//         ),

//     },


//     {

//         title:
//             "Amount Paid",

//         dataIndex:
//             "amount_paid",

//         key:
//             "amount_paid",

//         render: value => (

//             <Tag

//                 color="green"

//             >

//                 {Number(

//                     value || 0

//                 ).toFixed(2)}

//             </Tag>

//         ),

//     },


//     {

//         title:
//             "Balance",

//         dataIndex:
//             "balance",

//         key:
//             "balance",

//         render: value => (

//             <Tag

//                 color={

//                     Number(

//                         value || 0

//                     ) > 0

//                         ? "red"

//                         : "green"

//                 }

//             >

//                 {Number(

//                     value || 0

//                 ).toFixed(2)}

//             </Tag>

//         ),

//     },


//     {

//         title:
//             "Month",

//         dataIndex:
//             "month",

//         key:
//             "month",

//         render: value => (

//             value

//                 ? value
//                     .charAt(0)
//                     .toUpperCase()
//                     +
//                     value.slice(1)

//                 : "N/A"

//         ),

//     },

// ];


// return (

//     <Modal

//         open={
//             open
//         }

//         onCancel={
//             onClose
//         }

//         footer={
//             null
//         }

//         width={
//             1100
//         }

//         centered

//         destroyOnClose

//         title={

//             <div

//                 style={{

//                     display:
//                         "flex",

//                     alignItems:
//                         "center",

//                     gap:
//                         10,

//                     fontWeight:
//                         700,

//                     fontSize:
//                         18,

//                 }}

//             >

//                 <DollarOutlined />

//                 Payment Details

//             </div>

//         }

//     >

//         {/* DOWNLOAD RECEIPT BUTTON */}

//         <div

//             style={{

//                 display:
//                     "flex",

//                 justifyContent:
//                     "flex-end",

//                 marginBottom:
//                     20,

//             }}

//         >

//             <Button

//                 type="primary"

//                 icon={

//                     <DownloadOutlined />

//                 }

//                 onClick={

//                     handleDownloadReceipt

//                 }

//                 loading={

//                     downloadingReceipt

//                 }

//                 disabled={

//                     loading ||
//                     paymentHistory.length === 0

//                 }

//             >

//                 Download Receipt

//             </Button>

//         </div>


//         {/* PAYMENT SUMMARY */}

//         {payment && (

//             <Descriptions

//                 bordered

//                 column={{

//                     xs:
//                         1,

//                     sm:
//                         2,

//                     md:
//                         3,

//                 }}

//                 style={{

//                     marginBottom:
//                         24,

//                 }}

//             >

//                 <Descriptions.Item

//                     label="Fee Type"

//                 >

//                     {

//                         payment.fee_type_name

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Payer"

//                 >

//                     {

//                         payment.payer_name

//                             ||

//                         "N/A"

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Student"

//                 >

//                     {

//                         payment.student_name

//                             ||

//                         "Manual Payer"

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Class"

//                 >

//                     {

//                         payment.student_class_name

//                             ||

//                         "N/A"

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Academic Year"

//                 >

//                     {

//                         payment.academic_year_name

//                             ||

//                         "N/A"

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Date"

//                 >

//                     {

//                         payment.date

//                             ||

//                         "N/A"

//                     }

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Total Amount"

//                 >

//                     <strong>

//                         {Number(

//                             payment.total_amount

//                                 ||

//                             0

//                         ).toFixed(2)}

//                     </strong>

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Amount Paid"

//                 >

//                     <Tag

//                         color="green"

//                     >

//                         {Number(

//                             payment.amount_paid

//                                 ||

//                             0

//                         ).toFixed(2)}

//                     </Tag>

//                 </Descriptions.Item>


//                 <Descriptions.Item

//                     label="Balance"

//                 >

//                     <Tag

//                         color={

//                             Number(

//                                 payment.balance

//                                     ||

//                                 0

//                             ) > 0

//                                 ? "red"

//                                 : "green"

//                         }

//                     >

//                         {Number(

//                             payment.balance

//                                 ||

//                             0

//                         ).toFixed(2)}

//                     </Tag>

//                 </Descriptions.Item>

//             </Descriptions>

//         )}


//         {/* PAYMENT HISTORY */}

//         <h3>

//             Payment History

//         </h3>


//         {loading ? (

//             <div

//                 style={{

//                     textAlign:
//                         "center",

//                     padding:
//                         40,

//                 }}

//             >

//                 <Spin

//                     size="large"

//                 />

//             </div>

//         ) : paymentHistory.length === 0 ? (

//             <Empty

//                 description="No payment history found."

//             />

//         ) : (

//             <Table

//                 rowKey="id"

//                 columns={

//                     columns

//                 }

//                 dataSource={

//                     paymentHistory

//                 }

//                 pagination={{

//                     pageSize:
//                         5,

//                     showSizeChanger:
//                         true,

//                 }}

//                 scroll={{

//                     x:
//                         true,

//                 }}

//             />

//         )}

//     </Modal>

// );


// };

// export default FeesDetailsPopup;




